import Table from "@mui/material/Table";
import { PaDocumentV2 } from "../../types/types";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {currPathValue } from "../../types/enums";
import Typography from '@mui/material/Typography';
import store from "../../configureStore";
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import GradeIcon from '@mui/icons-material/Grade';
import IconButton from "@mui/material/IconButton";
import { fields, mapFieldToText } from "../../lang/constants";
import SyncIcon from '@mui/icons-material/Sync';

interface DocumentListProps {
    documents: PaDocumentV2[];
    invokePath: currPathValue;
    currentPath: currPathValue;
    getDocumentData: (headerText:string, docRno:number, prevPath:currPathValue) => void;
    favoriteClick: (docRno:number, isFavorite:boolean) => void;
    refresh: (value: currPathValue)=> void;
}

export const DocumentList = (props:DocumentListProps) => {
    const vaforiteDocs:PaDocumentV2[] = store.getState().uiItems.favoriteDocuments;
    return (
            <Table size="small" padding="none">
                <TableRow>
                    <TableCell>
                        <Typography>{mapFieldToText(fields.COUNT)}: {props.documents.length}</Typography>
                    </TableCell>
                    <TableCell>
                         <IconButton
                                aria-label="refresh"
                                color="inherit"
                                size="medium"
                                onClick={() => {
                                props.refresh(props.currentPath);
                                }}
                            >
                                <SyncIcon fontSize="inherit" />
                          </IconButton>
                    </TableCell>
                </TableRow>
                {props.documents.map((item:PaDocumentV2) => {
                const isFavorite = vaforiteDocs.filter(x=>x.documentRno === item.documentRno).length === 0 ? false : true ;
                return  <TableRow>
                            <TableCell onClick={()=> props.getDocumentData(`${item.documentId} - ${item.documentTitle}`, item.documentRno, props.invokePath)}>
                                <Typography variant="h6"><b>{item.documentId}</b></Typography>
                                <Typography>{item.documentTitle}</Typography>
                                <Typography variant="h6"><i>{item.repositoryName}</i></Typography>
                            </TableCell>
                            <TableCell>
                                <IconButton
                                    edge="end"
                                    aria-label="add to favorites"
                                    onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                        props.favoriteClick(item.documentRno, isFavorite);
                                    }}
                                    color="inherit"
                                    >
                                        {isFavorite && <GradeIcon />}
                                        {!isFavorite && <StarOutlineIcon />}
                                </IconButton>           
                            </TableCell>
                        </TableRow>
                    } 
                    )
                }  
            </Table>
    )
}